<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
window.addEventListener('contextmenu', function (e) {
  e.preventDefault();
});
window.addEventListener('popstate', (event) => {
  // 阻止默认的返回操作
  event.preventDefault();
  // 你可以在这里执行你的自定义操作，比如弹出提示框或者禁止返回
});
</script>

<style lang="less">
.size{
  width: 100%;
  height: 100%;
}
html,body{
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
</style>
